import { OperationVariables, QueryResult, useQuery } from '@apollo/client';
import GET_STUDENT from 'graph/queries/students/get-student';
import { Student } from 'types';

export type StudentStoreState = {
  student?: Student;
  isLoading: boolean;
};

export type StudentStoreDispatch = {
  studentRefetch: any;
};
export type StudentStore = [StudentStoreState, StudentStoreDispatch];

const useStudentStore = (id: number): StudentStore => {
  const {
    data,
    loading,
    refetch: studentRefetch,
  }: QueryResult<{ student: Student }> = useQuery(GET_STUDENT, {
    variables: { where: { id: id } } as OperationVariables,
  });

  return [
    {
      student: data?.student,
      isLoading: loading,
    },
    {
      studentRefetch,
    },
  ];
};

export default useStudentStore;
